var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('img',{staticStyle:{"height":"40px"},attrs:{"src":_vm.logo,"alt":"logo"}}):_c('div',{staticClass:"jrm-logo jrm-logo-blue"})}
var staticRenderFns = []

export { render, staticRenderFns }